import styled from 'styled-components'

export const ValuesRentContractWrap = styled.div``
